export class ParentProjectListingModel {
    constructor() {
        this.parentProjectName = "";
        this.parentProjectCode = 0;
    }
}
export default class ParentProjectListing extends ParentProjectListingModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
